import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import {
  NavigationStart,
  Router,
  NavigationEnd,
  ActivatedRoute,
} from '@angular/router';
import { AlertService } from './helper/service/alert.service';
import { PrimeNGConfig } from 'primeng/api';
import { settings } from './helper/interface/user';
import { SettingsService } from './helper/service/settings.service';

import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastModule, ConfirmPopupModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  setting: settings = {} as settings;
  loading: boolean = false;
  constructor(
    private alertService: AlertService,
    private router: Router,
    private titleServ: Title,
    protected activeRoute: ActivatedRoute,
    private SettingsService: SettingsService,
    private primeConfig: PrimeNGConfig,
  ) {
    this.setting = this.SettingsService.snapshot || ({} as settings);
    this.titleServ.setTitle(this.setting.siteName);
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (event instanceof NavigationEnd) {
        this.loading = false;
      }
    });
  }
  ngOnInit(): void {
    this.primeConfig.ripple = true;
    this.loading = false;
  }
  onclick() {
    this.alertService.clearToast();
  }
}
